<igx-stepper #stepper>
    <igx-step #kidStep [completed]="kidOk()">
        <ng-template igxStepActiveIndicator><igx-icon>edit</igx-icon></ng-template>
        <ng-template igxStepInvalidIndicator><igx-icon>error</igx-icon></ng-template>
        <ng-template igxStepCompletedIndicator><igx-icon>check</igx-icon></ng-template>
        <span igxStepTitle>Дете</span>
        @if(kid?.name) {
        <span igxStepSubtitle>{{ kid!.name }}</span>
        }
        @else {
        <span igxStepSubtitle class="error">{{ 'Не е избрано' }}</span>
        }
        <igx-card class="content" igxStepContent>
            <igx-card-content class="content">
                <div class="child">
                    <h5>ЗАЯВКА</h5>
                    <h5></h5>
                    <h5>ОБНОВЯВАНЕ</h5>
                    <h5></h5>
                    <h5>ИЗБРАНО ДЕТЕ</h5>

                    <span>{{ request?.kidName ?? '..................' }}</span>
                    <button igxButton="flat" [disabled]="!request?.kidName"
                        (click)="name.value = request!.kidName"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                    <igx-input-group type="border" class="grid-inputs">
                        <label igxLabel>Име и фамилия на детето</label>
                        <input #name igxInput [igxTextSelection]="true" [value]="kid?.name ?? request?.kidName" />
                    </igx-input-group>
                    <button igxButton="flat" [disabled]="!kid?.name"
                        (click)="name.value = kid!.name"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                    <span>{{ kid?.name ?? '..................' }}</span>

                    <span>{{ request?.kidBirth?.toLocaleDateString('bg-BG') ?? '..................' }}</span>
                    <button igxButton="flat" [disabled]="!request?.kidBirth"
                        (click)="kidBirth.value = request!.kidBirth"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                    <igx-date-picker #kidBirth type="border" [value]="kid?.birthDate ?? request?.kidBirth ?? ''"
                        class="grid-inputs">
                        <label igxLabel>Дата на раждане</label>
                    </igx-date-picker>
                    <button igxButton="flat" [disabled]="!kid?.birthDate"
                        (click)="kidBirth.value = kid!.birthDate!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                    <span>{{ kid?.birthDate?.toLocaleDateString('bg-BG') ?? '..................' }}</span>

                    <span>{{ request?.kidFootSize ?? '..................' }}</span>
                    <button igxButton="flat" [disabled]="!request?.kidFootSize"
                        (click)="footSize.value = request!.kidFootSize"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                    <igx-input-group type="border" class="grid-inputs">
                        <label igxLabel>Обувки №</label>
                        <input #footSize igxInput [igxTextSelection]="true"
                            [value]="kid?.footSize ?? request?.kidFootSize" />
                    </igx-input-group>
                    <button igxButton="flat" [disabled]="!kid?.footSize"
                        (click)="footSize.value = kid!.footSize!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                    <span>{{ kid?.footSize ?? '..................' }}</span>

                    <span>{{ request?.kidHeight ?? '..................' }}</span>
                    <button igxButton="flat" [disabled]="!request?.kidHeight"
                        (click)="height.value = request!.kidHeight"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                    <igx-input-group type="border" class="grid-inputs">
                        <label igxLabel>Височина</label>
                        <input #height igxInput [igxTextSelection]="true" [value]="kid?.height ?? request?.kidHeight" />
                    </igx-input-group>
                    <button igxButton="flat" [disabled]="!kid?.height"
                        (click)="height.value = kid!.height!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                    <span>{{ kid?.height ?? '..................' }}</span>

                    <span>{{ renderStop(request?.stopMorning!) }}</span>
                    <button igxButton="flat" [disabled]="!request?.stopMorning"
                        (click)="stop.value = renderStop(request?.stopMorning!)"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                    <igx-input-group type="border" class="grid-inputs">
                        <label igxLabel>Спирка</label>
                        <input #stop igxInput [igxTextSelection]="true"
                            [value]="kid?.morningStop?.name ?? renderStop(request?.stopMorning!)" />
                    </igx-input-group>
                    <button igxButton="flat" [disabled]="!kid?.morningStop?.name"
                        (click)="stop.value = kid!.morningStop?.name!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                    <span>{{ kid?.morningStop?.name ?? '..................' }}</span>


                    <button igxButton="outlined" (click)="addKid($event, kidForm, addKidDialog)" [disabled]="kid">Добави
                        дете</button>
                    <div></div>
                    <button igxButton="outlined" (click)="editKid(kidForm, addKidDialog)" [disabled]="!kid">Редактирай
                        дете</button>
                    <div></div>
                    <igx-simple-combo [data]="kids" type="border" [valueKey]="'id'" displayKey="name"
                        [ngModel]="kid?.id" (selectionChanging)="kidSelected($event)">
                        <label igxLabel>Избери дете</label>
                    </igx-simple-combo>
                </div>
            </igx-card-content>
            <igx-card-actions>
                <button igxButton="outlined" igxEnd (click)="deleteDialog.open()">Изтрий</button>
                <button igxButton="contained" igxEnd (click)="this.done.emit()">Обработи по-късно</button>
            </igx-card-actions>
        </igx-card>
    </igx-step>
    <igx-step #parentStep [completed]="parentOk()">
        <span igxStepTitle>Родител</span>
        @if(parent?.name) {
        <span igxStepSubtitle>{{ parent!.name }}</span>
        }
        @else {
        <span igxStepSubtitle class="error">{{ 'Не е избран' }}</span>
        }
        <span igxStepSubtitle *ngIf="secondParent">Втори {{ secondParent.name }}</span>
        <div class="content" igxStepContent>
            <div class="parent">
                <h5>ЗАЯВКА</h5>
                <h5></h5>
                <h5>ОБНОВЯВАНЕ</h5>
                <h5></h5>
                <h5>ИЗБРАН РОДИТЕЛ</h5>

                <span>{{ request?.parentName ?? '..................' }}</span>
                <button igxButton="flat" [disabled]="!request?.parentName"
                    (click)="parentName.value = request!.parentName!"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                <igx-input-group type="border" class="grid-inputs">
                    <label igxLabel>Име и фамилия на родителя</label>
                    <input #parentName igxInput [igxTextSelection]="true"
                        [value]="parent?.name ?? request?.parentName" />
                </igx-input-group>
                <button igxButton="flat" [disabled]="!parent?.name"
                    (click)="parentName.value = parent!.name"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                <span>{{ parent?.name ?? '..................' }}</span>

                <span>{{ request?.parentEmail ?? '..................' }}</span>
                <button igxButton="flat" [disabled]="!request?.parentEmail"
                    (click)="email.value = request!.parentEmail!"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                <igx-input-group type="border" class="grid-inputs">
                    <label igxLabel>e-mail</label>
                    <input #email igxInput [igxTextSelection]="true" [value]="parent?.email ?? request?.parentEmail" />
                </igx-input-group>
                <button igxButton="flat" [disabled]="!parent?.email"
                    (click)="email.value = parent?.email!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                <span>{{ parent?.email ?? '..................' }}</span>

                <span>{{ request?.parentPhone ?? '..................' }}</span>
                <button igxButton="flat" [disabled]="!request?.parentPhone"
                    (click)="phone.value = request!.parentPhone!"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                <igx-input-group type="border" class="grid-inputs">
                    <label igxLabel>Телефонен №</label>
                    <input #phone igxInput [igxTextSelection]="true" [value]="parent?.phone ?? request?.parentPhone" />
                </igx-input-group>
                <button igxButton="flat" [disabled]="!parent?.phone"
                    (click)="phone.value = parent?.phone!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                <span>{{ parent?.phone ?? '..................' }}</span>

                <button igxButton="outlined" (click)="addParent($event, parentForm, parentDialog)"
                    [disabled]="parent">Добави
                    родител</button>
                <div></div>
                <button igxButton="outlined" (click)="editParent(parentForm, parentDialog)" [disabled]="!parent">Обнови
                    родител</button>
                <div></div>
                <igx-simple-combo [data]="parents" type="border" [valueKey]="'id'" displayKey="name"
                    [ngModel]="parent?.id" (selectionChanging)="parentSelected($event)">
                    <label igxLabel>Избери родител</label>
                </igx-simple-combo>

                <!-- SECOND PARENT -->
                <span>{{ request?.secondParentName ?? '..................' }}</span>
                <button igxButton="flat" [disabled]="!request?.secondParentName"
                    (click)="secondParentName.value = request!.secondParentName!"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                <igx-input-group type="border" class="grid-inputs">
                    <label igxLabel>Име и фамилия втори родител</label>
                    <input #secondParentName igxInput [igxTextSelection]="true"
                        [value]="secondParent?.name ?? request?.secondParentName" />
                </igx-input-group>
                <button igxButton="flat" [disabled]="!secondParent?.name"
                    (click)="secondParentName.value = secondParent!.name"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                <span>{{ secondParent?.name ?? '..................' }}</span>

                <span>{{ request?.secondParentPhone ?? '..................' }}</span>
                <button igxButton="flat" [disabled]="!request?.secondParentPhone"
                    (click)="secondPhone.value = request!.secondParentPhone!"><igx-icon>keyboard_double_arrow_right</igx-icon></button>
                <igx-input-group type="border" class="grid-inputs">
                    <label igxLabel>Телефонен № втори родител</label>
                    <input #secondPhone igxInput [igxTextSelection]="true"
                        [value]="secondParent?.phone ?? request?.secondParentPhone" />
                </igx-input-group>
                <button igxButton="flat" [disabled]="!secondParent?.phone"
                    (click)="secondPhone.value = secondParent?.phone!"><igx-icon>keyboard_double_arrow_left</igx-icon></button>
                <span>{{ secondParent?.phone ?? '..................' }}</span>

                <button igxButton="outlined" (click)="addSecondParent($event, parentForm, parentDialog)"
                    [disabled]="secondParent">Добави втори
                    родител</button>
                <div></div>
                <button igxButton="outlined" (click)="editSecondParent(parentForm, parentDialog)"
                    [disabled]="!secondParent">Обнови
                    втори
                    родител</button>
                <div></div>
                <igx-simple-combo [data]="parents | sorting" type="border" [valueKey]="'id'" displayKey="name"
                    [ngModel]="secondParent?.id" (selectionChanging)="secondParentSelected($event)">
                    <label igxLabel>Избери втори родител</label>
                </igx-simple-combo>
            </div>
        </div>
    </igx-step>
    <igx-step #programStep [completed]="programOk()" [disabled]="!parentOk()" (activeChange)="programStepSelected($event)">
        <ng-template igxStepActiveIndicator><igx-icon>edit</igx-icon></ng-template>
        <ng-template igxStepInvalidIndicator><igx-icon>error</igx-icon></ng-template>
        <ng-template igxStepCompletedIndicator><igx-icon>check</igx-icon></ng-template>
        <span igxStepTitle>Програма</span>
        <span igxStepSubtitle>Предстои записване</span>
        <div class="content" igxStepContent>
            <app-add-package #addPackage></app-add-package>
        </div>
    </igx-step>
    <igx-step #emailStep [disabled]="!programOk()">
        <ng-template igxStepActiveIndicator><igx-icon>edit</igx-icon></ng-template>
        <ng-template igxStepInvalidIndicator><igx-icon>error</igx-icon></ng-template>
        <ng-template igxStepCompletedIndicator><igx-icon>check</igx-icon></ng-template>
        <span igxStepTitle>e-mail</span>
        <span igxStepSubtitle>Изпращане на писмо</span>
        <div class="content" igxStepContent>
            <app-send-email (done)="done.emit(request!.state)" #sendEmail></app-send-email>
        </div>
    </igx-step>
</igx-stepper>
<igx-dialog #addKidDialog>
    <igx-dialog-title>{{ dialogText }} дете</igx-dialog-title>
    <app-edit-kid-form #kidForm (done)="kidDone($event, addKidDialog)"></app-edit-kid-form>
</igx-dialog>
<igx-dialog #parentDialog>
    <igx-dialog-title>{{ dialogText }} родител</igx-dialog-title>
    <app-edit-parent-form #parentForm (done)="parentDone($event, parentDialog)"></app-edit-parent-form>
</igx-dialog>
<igx-dialog #deleteDialog title="Изтрий заявка" message="Наистина ли искате да изтриете заявката!"
    leftButtonLabel="Да, изтрий" (leftButtonSelect)="deletePackage(deleteDialog)" rightButtonLabel="Не, архивирай"
    (rightButtonSelect)="archivePackage(deleteDialog)">

</igx-dialog>
<ng-template igxStepActiveIndicator><igx-icon>edit</igx-icon></ng-template>
<ng-template igxStepInvalidIndicator><igx-icon>error</igx-icon></ng-template>
<ng-template igxStepCompletedIndicator><igx-icon>check</igx-icon></ng-template>